import { Button } from '@pets-ui/Button/Button'
import { createSvgIcon } from '@pets-ui/Logos/createSvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useHistory } from 'react-router-dom-v5'
import CartEmptySvg from '../../assets/empty-cart.svg?react'
import { useStmCart } from '../CartProvider'

const CartEmptyIcon = createSvgIcon(CartEmptySvg)

export const CartEmpty = () => {
  const history = useHistory()
  const { basePath } = useStmCart()

  const handleClick = () => {
    history.push(`${basePath}/product-catalog`)
  }

  return (
    <VStack gap={5} minHeight="inherit" alignItems="center" justifyContent="center" py={10}>
      <CartEmptyIcon fontSize={160} />
      <Text variant="subtitle">購物車中沒有商品</Text>
      <Button onClick={handleClick}>去選購</Button>
    </VStack>
  )
}
